document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  function actualizarPrecio(variantId) {
    if (!variantId) return;
    fetch('/variants/' + variantId + '.js')
      .then(function (r) { return r.json(); })
      .then(function (variant) {
        const precio = (variant.price / 100)
          .toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        document.querySelectorAll('.price-item--regular').forEach(function (el) {
          el.textContent = '\u20AC' + precio;
        });
      });
  }

  document.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      setTimeout(function () {
        const id = form.querySelector('input[name="id"]');
        if (id) actualizarPrecio(id.value);
      }, 30);
    });
  });

  const idInput = form.querySelector('input[name="id"]');
  if (idInput) {
    new MutationObserver(function () {
      actualizarPrecio(idInput.value);
    }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }
});